import type { Icon } from '../../../src/lib/types'
export const mdiInboxOutline: Icon = {
  "id": "inbox-outline",
  "name": "Inbox Outline",
  "path": "M19 3H5A2 2 0 0 0 3 5V19A2 2 0 0 0 5 21H19A2 2 0 0 0 21 19V5A2 2 0 0 0 19 3M5 19V17H8.13A4.13 4.13 0 0 0 9.4 19M19 19H14.6A4.13 4.13 0 0 0 15.87 17H19M19 15H14V16A2 2 0 0 1 10 16V15H5V5H19Z",
  "as": [],
  "tags": []
}
export default mdiInboxOutline